import React, { useState, useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import LocalStorageService from '../../../services/LocalStorageService'
import NotificationService from '../../../services/NotificationService'
import ReportService from '../../../services/ReportService'
import UserTagService from '../../../services/UserTagService'

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Appt Components
import Box from '../../../components/simple/box/Box'
import Divider from '../../../components/simple/divider/Divider'
import FieldBox from '../shared/FieldBox.js'
import Form from '../../../components/simple/form/Form.js'
import FormField from '../../../components/simple/formField/FormField.js'
import FormFieldRequired from '../../../components/simple/formField/FormFieldRequired.js'
import JoinBox from '../shared/JoinBox.js'
import OperatorBox from '../shared/OperatorBox.js'
import Text from '../../../components/simple/text/Text'
import Select from '../../../components/simple/input/Select'
import TextInput from '../../../components/simple/input/TextInput'
import ValueBox from '../shared/ValueBox.js'

// utils
import constants from '../../../utils/constants'

import { reportsByType } from '../../../utils/reportMapping.js'

// Shared Components
import moment from 'moment'
import ActionButton from '../../../components/compound/actionButton/ActionButton.js'

function AnalyticsFilters (props) {
  const navigate = useNavigate()

  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg')
  const activeUser = LocalStorageService.get('userDetails')

  // Count of number of rows of queries
  const [criteriaIndex, setCriteriaIndex] = useState(0)

  // Array of field types for the currently
  // selected Field box
  const [fields, setFields] = useState([])

  // ???
  const [query, setQuery] = useState({
    'Field-0': '',
    'Value-0': ''
  })

  // Add to Quick Search has been clicked
  // so request the name
  const [getQuickSearchName, displayQuickSearchName] = useState(false)

  // List of Quick Searches
  const [quickReportSearches, setQuickReportSearches] = useState([])

  // Selected Quick Search
  const [quickSearchSelected, setQuickSearchValue] = useState([])

  const [fullSelectedQuickSearch, setFullSelectedQuickSearch] = useState([])

  // Set the submission type for the prop passed in
  const [submissionType, setSubmissionType] = useState(props.submissionType)

  const goBack = () => {
    history.goBack()
  }

  // Save the Quick Search just to Local Storage for now
  const saveQuickSearch = async (searchesToSave) => {
    var searchToSubmit = []
    searchToSubmit.push({
      organisation: activeOrg.id,
      user: activeUser.id,
      key: 'quickSearch',
      type: `combined`,
      value: JSON.stringify(searchesToSave)
    })

    const tagSet = await UserTagService.set(apiToken, searchToSubmit)
    if (tagSet.error) {
      NotificationService.error(tagSet.error)
    } else {
      NotificationService.success('Quick Search has been saved')
    }
  }

  // Save the Quick Search just to Local Storage for now
  const submitQuickSearch = async (values) => {
    const query = await buildQuery()

    const queryObject = {}

    queryObject.name = values.quickSearchName
    queryObject.query = query

    // let quickSearch = LocalStorageService.get('quickReportSearch')

    // if (!quickSearch) {
    //   quickSearch = []
    // }

    // quickSearch.push(queryObject)

    // LocalStorageService.set('quickReportSearch', quickSearch)

    const searchToSubmit = []

    var quickSearchArray = quickReportSearches

    quickSearchArray.push(queryObject)

    searchToSubmit.push({
      organisation: activeOrg.id,
      key: 'quickSearch',
      type: `combined`,
      value: JSON.stringify(quickSearchArray),
      user: activeUser.id
    })

    const tagSet = await UserTagService.set(apiToken, searchToSubmit)

    if (tagSet.error) {
      NotificationService.error(tagSet.error)
    } else {
      values.quickSearchName = ''
      displayQuickSearchName(false)
      NotificationService.success('Quick Search has been saved')
    }
  }

  const removeQuickSearch = async (selectedQuick) => {
    if (window.confirm('Are you sure you want to remove this quick search?')) {
      const valuesToSave = quickReportSearches.filter(s => s.name !== fullSelectedQuickSearch.name)
      await saveQuickSearch(valuesToSave)
      getQuickSearches()
    }
  }

  const getQuickSearches = () => {
    (async () => {
      const params = {
        fields: 'id,type,key,value',
        limit: 100,
        orgId: activeOrg.id
      }

      const where = {
        organisation: activeOrg.id,
        key: 'quickSearch',
        user: activeUser.id
      }


      const quickSearches = await UserTagService.get(apiToken, params, where)

      var searches = []

      if (quickSearches !== undefined) {
        for (const search of quickSearches) {
          if (search.value) {
            try {
              var value = JSON.parse(search.value)
              if (value) {
                searches = searches.concat(value)
              }

              // only only one search for each name
              searches = [...new Map(searches.map(item => [item.name, item])).values()]

            } catch (err) {
              console.error(err)
            }
          }
        }
      }

      // sort by name
      searches.sort((a, b) => {
        if (a.name < b.name) {
          return -1
        }
        if (a.name > b.name) {
          return 1
        }
        return 0
      })

      if (searches.length) {
        setQuickReportSearches(searches)
      } else {
        setQuickReportSearches([])
      }
    })()
  }

  // If a different field has been selected then
  // set the field type of the field selected
  // so that the Operator dropdown can be
  // populated accordingly
  const handleFieldChanged = (fieldName, value) => {
    const fieldIndex = fieldName.substring(fieldName.indexOf('-') + 1)
    const newFields = fields

    newFields[fieldIndex] = value

    setFields(newFields)
  }

  // Delete a Criteria row
  const removeCriteria = (index) => {

    // Remove the query
    if (query && query[`Field-${index}`]) {
      delete query[`Field-${index}`]
    }

    if (query && query[`Query-${index}`]) {
      delete query[`Query-${index}`]
    }

    if (query && query[`Value-${index}`]) {
      delete query[`Value-${index}`]
    }

    if (query && query[`Join-${index}`]) {
      delete query[`Join-${index}`]
    }

    // Rename the remaining query keys
    // eg. Field-1 -> Field-0
    //
    // if current key > index decrement by 1
    const newQuery = {}

    for (const item in query) {
      const fieldName = item.split('-')[0]
      let fieldIndex = item.split('-')[1]
      const fieldValue = query[fieldName.concat('-', fieldIndex)]

      if (parseInt(fieldIndex) > index) {
        fieldIndex--
      }

      newQuery[fieldName.concat('-', fieldIndex)] = fieldValue
    }

    // Update new values
    const newFields = fields

    newFields.splice(index, 1)
    setFields(newFields)

    setQuery(newQuery)
    setCriteriaIndex(criteriaIndex - 1)
    buildCriteria()
  }

  // When Field changes default the Query box to the first option
  const setDefaultOperatorValue = (defautValue, index) => {
    if (query && query[`Field-${index}`]) {
      query[`Query-${index}`] = defautValue
    }
  }

  // One row of the query
  const criteriaRow = (index) => {
    return (
      <>
        <Box direction='row-responsive' gap='medium'>
          <FormField
            direction='column'
            label='Field'
            name={`Field-${index}`}
          >
            <FieldBox
              handleFieldChanged={handleFieldChanged}
              name={`Field-${index}`}
              reportType={props.reportSource}
            />
          </FormField>

          <FormField
            direction='column'
            label='Query'
            name={`Query-${index}`}
          >
            <OperatorBox
              index={index}
              name={`Query-${index}`}
              type={fields[index]?.type}
              operators={fields[index]?.operators}
              setDefaultOperatorValue={setDefaultOperatorValue}
              fieldType={fields[index]?.value}
              query={query}
            />
          </FormField>

          <FormField
            direction='column'
            label='Value'
            name={`Value-${index}`}
          >
            <ValueBox
              name={`Value-${index}`}
              type={fields[index]?.type}
              list={fields[index]?.list}
              fieldType={fields[index]?.value}
              index={index}
              query={query}
            />
          </FormField>

          <ActionButton label={<Text><FontAwesomeIcon icon={['fal', 'minus-circle']} /></Text>} margin={{ horizontal: 'xsmall', vertical: 'medium' }} style={{ background: 'besmartOrange' }} onClick={() => removeCriteria(index)} target='_self' />
        </Box>
      </>

    )
  }

  // Build the whole form by adding one
  // query row for each join option added
  const buildCriteria = () => {
    const criteriaTable = []

    for (let i = 0; i <= criteriaIndex; i++) {
      criteriaTable.push(criteriaRow(i))
    }

    if (criteriaIndex > 0) {
      criteriaTable.push(
        <Box direction='row-responsive' gap='medium'>
          <FormField
            direction='column'
            label='Find results that match'
            name='Join'
          >
            <JoinBox
              name='Join'
            />
          </FormField>
        </Box>)
    }

    return criteriaTable
  }

  // Add another row to the query
  const addCriteria = () => {
    // default the Join to AND
    query[`Join-${(criteriaIndex + 1)}`] = 'AND'
    setQuery(query)
    setCriteriaIndex(criteriaIndex + 1)
  }

  // Using the entered values post the query to
  // get the relevant report information
  const buildQuery = () => {
    let endOfQuery = false
    let queryCounter = 0
    const queryArray = []

    // If no query return an empty array
    if (query !== undefined) {
      // Add each query row to an array
      while (!endOfQuery) {
        if (
          query[`Field-${queryCounter}`]?.value === 'deescalationTechniques' ||
          query[`Field-${queryCounter}`]?.value === 'physicalTechnique'
        ) {
          queryArray.push({
            key: query[`Value-${queryCounter}`].split(' ').join(''),
            operator: 'has',
            response: null,
            relation: queryCounter > 0 && query.Join ? query.Join : null
          })
        } else {
          queryArray.push({
            key: query[`Field-${queryCounter}`]?.value,
            operator: query[`Query-${queryCounter}`],
            response: (query[`Field-${queryCounter}`].type === 'autocomplete' || query[`Field-${queryCounter}`].type === 'integer' || query[`Field-${queryCounter}`].type === 'text' || query[`Field-${queryCounter}`].type === 'time') ? query[`Value-${queryCounter}`] : query[`Field-${queryCounter}`].type === 'date' ? moment(query[`Value-${queryCounter}`]).format('YYYY-MM-DD') : query[`Value-${queryCounter}`].value,
            relation: queryCounter > 0 && query.Join ? query.Join : null
          })
        }


        queryCounter++
        var checkNextCriteria = `Field-${queryCounter}` in query

        if (!checkNextCriteria) {
          endOfQuery = true
        }
      }
    }

    return queryArray
  }

  // Check a valid query has been entered
  const validateQuery = () => {
    // Check a query has been entered
    if (query === undefined) {
      return true
    }

    // allow default queries
    if (query['Field-0'] === '') {
      return true
    }

    // Now check each row has a Field, Operator and Value entered
    let endOfQuery = false
    let validQuery = true
    let queryCounter = 0

    while (!endOfQuery) {
      if (query[`Field-${queryCounter}`] === undefined || query[`Query-${queryCounter}`] === undefined || query[`Value-${queryCounter}`] === undefined) {
        validQuery = false
        endOfQuery = true
      }

      // const checkJoinCriteria = `Join-${queryCounter}` in query

      queryCounter++

      // Now test for the end of the query
      const checkNextFieldCriteria = `Field-${queryCounter}` in query
      const checkNextOperatorCriteria = `Query-${queryCounter}` in query
      const checkNextValueCriteria = `Value-${queryCounter}` in query

      if (!checkNextFieldCriteria && !checkNextOperatorCriteria && !checkNextValueCriteria) {
        endOfQuery = true
      }
    }

    return validQuery
  }

  const buildReport = async () => {
    // Only build the report if a valid query has been entered
    if (validateQuery()) {
      const queryArray = await buildQuery()

      props.onSubmit(queryArray)

    } else {
      NotificationService.warning('Please complete the query before continuing')
    }
  }

  const getReportViaQuickSearch = async (queryArray) => {

    const searchQuery = await buildQuery()
    // merge the query with the quick search
    queryArray = queryArray.concat(searchQuery)

    const results = await getReport(queryArray)

    navigate({
      pathname: `/report/${submissionType}`,
      state: results
    })
  }

  useEffect(() => {
    setCriteriaFromQuickSearch(props.filters)
  }, [props.filters])

  const setCriteriaFromQuickSearch = async (queryArray) => {
    let newQuery = {}
    for (const i in queryArray) {
      const savedQuery = queryArray[i]

      newQuery[`Field-${i}`] = constants.reportSearch.find((item) => item.value === savedQuery.key)
      newQuery[`Query-${i}`] = savedQuery.operator
      newQuery[`Value-${i}`] = savedQuery.response
      newQuery[`Join-${i}`] = savedQuery.relation ? savedQuery.relation : i === 0 ? null : 'AND'

      // handleFieldChanged(`Field-${i}`, newQuery[`Field-${i}`]?.value)
    }


    setQuery(newQuery)
    setCriteriaIndex(queryArray.length - 1)
  }

  const getReport = async (queryArray) => {
    if (queryArray) {

      let submissionTypeToUse = 'incidentreport'
      if (submissionType === 'medicalinterventionreport') {
        submissionTypeToUse = 'medicalinterventionreport'
      }

      if (submissionType === 'concernreport') {
        submissionTypeToUse = 'concern'
      }

      if (submissionType === 'clickerreport') {
        submissionTypeToUse = 'clicker'
      }


      const body = {
        // submissionType: (submissionType === 'medicalinterventionreport'
        //   ? 'medicalinterventionreport'
        //   : 'incidentreport'),
        submissionType: submissionTypeToUse,
        query: queryArray,
        reports: reportsByType[submissionType],
        // TODO: Need different fields !
        // fields: 'id,user,organisation,submission,questionKey,questionText,response',
        // limit: 1000
      };

      const params = {
        orgId: activeOrg.id
      }

      const results = await ReportService.getReport(apiToken, params, body)

      return results
    }
  }

  // Basically componentDidMount
  useEffect(() => {
    let unmounted = false

    if (!unmounted) {
      getQuickSearches()
    }

    return () => { unmounted = true }
  }, [])

  return (
    <Box width='xlarge' gap='medium' margin={{ top: 'none', bottom: 'medium' }}>

      {/* Main */}
      <Box background='white' direction='column' gap='small' round='small' flex='grow'>
        <Box direction='row-responsive' justify='between' pad={{ horizontal: 'medium', vertical: 'small' }}>
            <Text margin={{ top: 'small', bottom: 'small', horizontal: 'none' }} size='xlarge'>Filters</Text>
            <Box alignSelf='center' direction='row'>
               <Box
                margin={{ horizontal: 'medium', vertical: 'none' }}
                border={{ side: 'all', color: 'brand', size: 'medium' }}
                round="small"
              >
              <Select
                labelKey='name'
                name='quickSearch'
                placeholder='Saved Filters'
                onChange={({ value: nextValue }) => {
                  let selectedQuery = null
                  quickReportSearches.forEach((item) => {
                    if (item.name === nextValue) {
                      selectedQuery = item
                    }
                  })
                  setFullSelectedQuickSearch(selectedQuery)
                  setQuickSearchValue(selectedQuery.query)
                }}
                options={quickReportSearches}
                // NOTE: Normally we'd use 'query' as the key here
                // but because that is an array it seems to mess
                // things up and when selected the item does not
                // display in the dropdown. So we'll use the 'name'
                // and search for the 'query' when selected
                valueKey={{ key: 'name', reduce: true }}
                border={false}
                round="small"
                focusIndicator={false}
                plain
                margin={{ left: 'small', right: 'small' }}
              />
              </Box>
              {quickSearchSelected?.length > 0 && <ActionButton
                disabled={!quickSearchSelected.length}
                label='Return Search'
                margin={{ horizontal: 'xsmall' }}
                onClick={() => setCriteriaFromQuickSearch(quickSearchSelected)}
                target='_self'
              />}
              {quickSearchSelected?.length > 0 && <ActionButton
                disabled={!quickSearchSelected?.length}
                label='Delete Saved Filters'
                grey
                margin={{ horizontal: 'xsmall' }}
                onClick={() => removeQuickSearch(quickSearchSelected)}
                target='_self'
              />}
              {!getQuickSearchName && criteriaIndex > -1 &&
                  <ActionButton
                    onClick={(  ) => {
                      if (validateQuery()) {
                        displayQuickSearchName(true)
                      }
                    }}
                    label={'Save Filters'}
                    margin={{ horizontal: 'xsmall' }} target='_self'
                  />}
            </Box>
          </Box>

            <Box direction='row-responsive' justify='end' pad={{ horizontal: 'none', vertical: 'none' }}>

                {getQuickSearchName &&
                  <Form
                    onSubmit={({ value: nextValue }) => {
                      submitQuickSearch(nextValue)
                    }}
                  >
                    <Box alignSelf='center' direction='row'>
                    <FormFieldRequired
                      direction='row'
                      label='Quick Search Name'
                      name='quickSearchName'
                      required
                    >
                      <TextInput
                        name='quickSearchName'
                        type='text'
                      />
                    </FormFieldRequired>

                    <ActionButton type='submit' label='Save' primary height='small' />
                     </Box>
                  </Form>}

            </Box>
          {quickSearchSelected?.length > 0 &&<Divider color='light-4' margin={{ top: 'none', bottom: 'small' }} />}
        <Box
          gap='small'
          margin={{ horizontal: 'small' }}
          pad='small'
          round='small'
        >


            <Form
              onChange={nextValue => {
                setQuery(nextValue)
              }}
              onSubmit={({ value: nextValue }) => {
                buildReport(nextValue)
              }}
              value={query}
            >
              <Box direction='column' gap='xsmall' margin={{ bottom: 'small' }}>
                {buildCriteria()}
                {/* <ActionButton icon={<AddCircle size='medium' />} label='Add Criteria' color='primary' onClick={() => addCriteria()} style={{ height: '35px' }} alignSelf='start' margin={{ bottom: 'small' }} /> */}
                <ActionButton label={<Text><FontAwesomeIcon icon={['fal', 'plus-circle']} /> Add Filter</Text>} color='primary' onClick={() => addCriteria()} alignSelf='start' margin={{ bottom: 'small' }} />
              </Box>


              <Box direction='row' justify='end' margin={{ top: 'medium' }} border={{ side: 'top', color: 'light-4' }} pad={{ top: 'medium' }}>
                <ActionButton type='submit' label='Apply Filters' primary />
              </Box>
            </Form>
        </Box>
      </Box>
    </Box>
  )
}

export default AnalyticsFilters
